'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosReverseCamera = function IoIosReverseCamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.7 12.5c1.4 0 2.3 1.1 2.3 2.4v13.8c0 1.3-0.9 2.6-2.3 2.6h-25c-1.4 0-2.7-1.3-2.7-2.6v-13.8c0-1.3 1.3-2.4 2.7-2.4h1v-1.2h2.6v1.2h1c2.5-2.8 3.4-3.7 4.3-3.7h6.9c1 0 1.8 0.9 4.3 3.7h4.9z m-8.2 13.4l0.1-0.2-0.9-0.9-0.1 0.1c-1 0.9-2.3 1.4-3.6 1.4-2.8 0-5.2-2.3-5.5-4.9h2.4l-3.1-3.9-2.9 3.9h2.3c0.4 3.3 3.3 6.1 6.8 6.1 1.6 0 3.2-0.5 4.5-1.6z m1.7-1.9l2.9-4h-2.3c-0.2-1.6-0.9-3.4-2.1-4.5-1.3-1.1-3-1.7-4.7-1.7-1.6 0-3.2 0.5-4.5 1.6l-0.1 0.1 0.9 1 0.1-0.2c1-0.8 2.3-1.3 3.6-1.3 2.8 0 5.2 2.3 5.5 5h-2.4z' })
        )
    );
};

exports.default = IoIosReverseCamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-reverse-camera.js
// module id = 2300
// module chunks = 0